import { CarriersI } from '../interfaces/carriers.interface'
import { CarriersService } from '../services/carriers.service'
import {
    CarrierCreatePayloadT,
    CarrierTripartiteAgreementPayload,
    CarrierUpdatePayloadT,
    CarriersCreateCarrierResponseT,
    CarriersDownloadExcelPayloadT,
    CarriersDownloadExcelResponseT,
    CarriersGetCarrierResponseT,
    CarriersGetContractInfoResponseT,
    CarriersGetListResponseT,
    VehicleOwnerUpdateT,
} from '../types/carriers.types'

const carriersService = new CarriersService()

class CarriersRealisation implements CarriersI {
    getList(params: any): Promise<CarriersGetListResponseT> {
        return carriersService.getList(params)
    }

    getCarrier(carrier_id: number): Promise<CarriersGetCarrierResponseT> {
        return carriersService.getCarrier(carrier_id)
    }

    getContractInformation(bin: string): Promise<CarriersGetContractInfoResponseT> {
        return carriersService.getContractInformation(bin)
    }

    createCarrier(carrier_payload: CarrierCreatePayloadT): Promise<CarriersCreateCarrierResponseT> {
        return carriersService.createCarrier(carrier_payload)
    }

    updateCarrier(carrier_id: number, carrier_payload: CarrierUpdatePayloadT): Promise<void> {
        return carriersService.updateCarrier(carrier_id, carrier_payload)
    }

    updateVehicleOwner(vehicle_owner_payload: VehicleOwnerUpdateT): Promise<void> {
        return carriersService.updateVehicleOwner(vehicle_owner_payload)
    }

    resendTo1C(carrier_id: number): Promise<void> {
        return carriersService.resendTo1C(carrier_id)
    }

    addCarriersJira(): Promise<void> {
        return carriersService.addCarriersJira()
    }

    exportExcel(params: CarriersDownloadExcelPayloadT): Promise<CarriersDownloadExcelResponseT> {
        return carriersService.exportExcel(params)
    }

    tripartiteAgreement(payload: CarrierTripartiteAgreementPayload): Promise<void> {
        return carriersService.tripartiteAgreement(payload)
    }
}

export const carriers = new CarriersRealisation()
